export default __webpack_public_path__ + "static/media/christmasLogo.c4ee7acd.png";